export default __webpack_public_path__ + "static/media/trial-ends.e4713930.svg";